import styled from "styled-components";
import { sharedTertiaryCTAMixin, ShareTertiaryCTAProps } from "../Button/V3TertiaryCTA.styles";

export const V3TertiaryCTALink = styled.a<ShareTertiaryCTAProps>`
    display: inline-block;
    text-decoration: none;
    ${sharedTertiaryCTAMixin};
`;
